export const TagType = {
  DEVICE: "device",
};
